var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4843 97.4828L14.5172 26.4843L85.5157 14.5172L97.4828 85.5157L26.4843 97.4828Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8961 71.8042C71.6345 73.7909 73.4756 75.6649 76.6173 75.1354C79.256 74.6906 80.4195 73.1458 80.1136 71.3313C79.7476 69.16 78.1859 68.6302 75.0697 67.8553L73.3638 67.4452C68.4422 66.2709 64.9757 64.3442 64.1065 59.187C63.3053 54.434 66.3344 50.2037 72.0202 49.2454C76.069 48.5629 79.2144 49.4748 81.9317 52.7933L77.5079 56.7983C76.0888 55.0336 74.7801 54.4652 72.9519 54.7734C71.0862 55.0878 70.1034 56.4644 70.3626 58.0027C70.6831 59.9038 71.9961 60.4735 74.926 61.1905L76.6319 61.6007C82.4341 62.9937 85.884 64.8339 86.7762 70.1272C87.7375 75.8308 83.76 79.7159 77.7132 80.7351C71.7987 81.732 67.9398 79.33 65.4508 75.971L69.8961 71.8042ZM47.0737 75.8173C48.3728 77.4359 50.1211 78.5549 52.3023 78.1872C54.3889 77.8355 55.451 76.8087 54.9108 73.6039L51.3908 52.7205L57.9641 51.6125L61.6543 73.5057C62.7735 80.1461 59.4311 83.8166 53.8065 84.7647C48.7242 85.6213 44.4755 82.7962 42.4414 79.8493L47.0737 75.8173Z",
    fill: "#000001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0.689606 16.6457) rotate(-9.5675)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconjs);
export default __webpack_public_path__ + "static/media/iconjs.684fbe8c681b865bd522b5d38edd8cc9.svg";
export { ForwardRef as ReactComponent };